import { 
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChildren, } from '@angular/core';
  import {
    BaseFpxComponentState,
    BaseFpxFormHelper,
    HttpProviderService,
    IHttpSuccessPayload,
    RoutingInfo,
    BaseFpxChangeHandler,
    BaseFpxControlEventHandler,
    HttpRequest,
    SpinnerService,
    ILookupResponse,
    CriteriaQuery,
  } from "@fpx/core";
import { CommonService } from "src/app/common.service";
import { FormControlTemplatesDirective } from "../form-control-templates.directive";
import { FormControlTemplatesService } from "../form-control-templates.service";
import { AccountsService } from "src/app/services/accounts/accounts.service";
import { AccountDetails } from "src/app/models/account-info.model";
import { PfmMainService } from 'src/app/pfm/services/pfm-main.service';
import { UserService } from 'src/app/user.service';
import { environment } from 'src/environments/environment';
import { FileOpenerService } from "src/app/services/mobile/file-opener.service";
import { CBXSwipeFromTo } from 'src/app/fpx-core/components/fpx-swipe/fpx-swipe.model';


@Component({
  selector: 'form-ro-grid-templates',
  templateUrl: './form-ro-grid-templates.component.html',
  styleUrls: ['./form-ro-grid-templates.component.scss']
})
export class FormRoGridTemplatesComponent implements OnInit {
  @ViewChildren(FormControlTemplatesDirective)
  templateRefs: QueryList<FormControlTemplatesDirective>;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter<any>();
  transfersSwipeLeft: any[];

  constructor(
    private _formControlTmpltService: FormControlTemplatesService,
    public commonService: CommonService,
    public userService: UserService,
    public _accountsService: AccountsService,
    public pfmMainService:PfmMainService,
    private _fileOpener: FileOpenerService, 
    private _httpProvider : HttpProviderService,
  ) {}

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    this._formControlTmpltService.displayGridTmpltRefs = this.templateRefs;
    this._setTransferSwipeConfig()
  }


  downloadFile(inventoryNumber) {

    const httpRequest = new HttpRequest();
    httpRequest.setMethod('GET');
    httpRequest.setResource('/documentdownload/{inventoryNumber}');
    httpRequest.addPathParameter('inventoryNumber', inventoryNumber);
    httpRequest.addQueryParameter('documentType', "PASSPORT");
    httpRequest.setServerContext(environment.commonPublisher);
    this._httpProvider.invokeDownloadApi(httpRequest).pipe(
    ).subscribe({
      next: (response: any) => {
        this.commonService.hideSpinner();
        let fileName = this.commonService.decodeFileName(response);
        let fileType = fileName ? fileName.split('.') : undefined;
        let mimeType = this.commonService.getFileMimeType(fileType ? fileType?.[fileType?.length - 1] : 'pdf');
        if (this.commonService.isHybrid()) {
          this._fileOpener.openPDF(response, mimeType, fileName);
        }
        else {
          let documentURL = URL.createObjectURL(new Blob([response.body], { type: mimeType }));
          const downloadLink = document.createElement("a");
          downloadLink.href = documentURL;
          downloadLink.download = fileName;
          downloadLink.click();
        }
      }, error: (err: any) => {
        this.commonService.hideSpinner();
      }
    })
  }

  private _setTransferSwipeConfig() {
    let swipe = new CBXSwipeFromTo();
    swipe.addLeftSwipe(
      ".list-${index}",
      { css: { x: 0, boxShadow: "unset", borderRadius: "none" } },
      {
        css: {
          x: "-259px",
          boxShadow: "0px 3px 29px #00000029",
          borderRadius: "12px",
        },
      }
    );
    this.transfersSwipeLeft = swipe?.swipeLeft;
  }
}